import {
    CompoundOrigin, CompoundTranslationType, DataQuality, PolygonType,
    RemovalReason, ScreeningFlag, ScreeningStatus
} from '../enums';
import { LocationInfo } from '../common';
import { Industry } from './industry';
import { Activity } from './activity';
import { ScreeningLog } from './screening-log';
import { ScreeningStandardparameters } from './screening-standard-parameters';
import { ScreeningPolygonResult } from './screening-polygon-result';

export class ScreeningLocationDetailView {
    public id: string;
    public location: LocationInfo;
    public hasV1Polygon: boolean;
    public hasV2Polygon: boolean;
    public v1PolygonResult: ScreeningPolygonResult;
    public v2PolygonResult: ScreeningPolygonResult;
    public v1Screenings: Array<ScreeningLocationResultItem>;
    public v2Screenings: Array<ScreeningLocationResultItem>;
    public totalFlags: ScreeningFlag;
    public screeningLog: ScreeningLog;

    public constructor(init: Partial<ScreeningLocationDetailView>) {
        Object.assign(this, init);
    }
}

export class ScreeningLocationResultItem {
    public id: string;
    public createdAt: Date;
    public status: ScreeningStatus;
    public industry: Industry;
    public activity: Activity;
    public compoundName: string;
    public compoundCasNr: string;
    public qualityCriterion: number;
    public worstCaseConcentration: number;
    public concentrationDownstream: number;
    public removed: boolean;
    public removalReason: RemovalReason;
    public factor: number;
    public dataQuality: DataQuality;
    public flag: ScreeningFlag;
    public polygonArea: number;
    public polygonType: PolygonType;
    public standardParameters: ScreeningStandardparameters;
    public sourceSize: number;
    public compoundOrigin: CompoundOrigin;
    public compoundTranslationType: CompoundTranslationType;
}
